import axios from 'axios';

const api = axios.create({ 
    baseURL: "https://api.mos.gg/v1"

});

api.interceptors.request.use(async config => {
    const token = sessionStorage.getItem('authorization');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

export default api;